import { useCallback } from "react";
import { useAuth } from "@clerk/react";
import { api } from "@/lib/api";

export default function useAdminApi() {
  const { getToken } = useAuth();
  return useCallback(async (method, url, data) => {
    const token = await getToken();
    const r = await api.request({ method, url, data, headers: { Authorization: `Bearer ${token}` } });
    return r.data;
  }, [getToken]);
}
